import React from 'react';
import PropTypes from 'prop-types';
import {Outcome} from '../Outcome';
import './style.scss';

/**
 * StartNode:
 *  - Component to display StartNode Components
 *    They are the first Node in DesignViewOne, DesignViewTwo & DesignViewThree
 *    They typically house the Outcome [HexagonCard] component
 */
export function StartNode(props) {
  const outcomeComponent = (c) => {
    return React.createElement(props.outcomeNode, {
      key: c.id,
      title: c.title,
      glossaryId: c.glossaryId,
      image: c.image,
      isEmpty: false,
      showFeedback: false,
      droppedId: c.droppedId,
      answerId: c.answerId,
      placeHolder: c.placeHolder,
      ...props.outcomeNode.props,
      tabIndex: props.tabIndex,
      feedbackMessage: c.feedbackMessage,
    });
  };

  let className = 'design-view__startNode';

  const totalNodeComponents = props.nodeComponents.length;

  if (totalNodeComponents >= 2) {
    className += ' startNode--2';
  }

  return (
    <div className={className}>
      {props.nodeComponents.map(outcomeComponent)}
    </div>
  );
}

StartNode.propTypes = {
  /**
   * List of Components too display in Node
   */
  nodeComponents: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * Uniqe id of component
       */
      id: PropTypes.number,
      /**
       * Type of NodeComponent
       */
      type: PropTypes.oneOf(['OUTCOME_CARD']),
      /**
       * Title of OutcomeNode
       */
      title: PropTypes.string,
      /**
       * Image URL for OutcomeNode
       */
      image: PropTypes.string,
    })
  ),
  /**
   * React Component to be used as Outcome Component
   */
  outcomeNode: PropTypes.elementType,
  /**
   * for keyboard navigation
   */
  tabIndex: PropTypes.number,
};

StartNode.defaultProps = {
  nodeComponents: [],
};
